<template>
	<div class="app-navigation flex-grow-default">
		<div v-for="item in sidebarItems" :key="item.slug">
			<sidebar-item
				v-if="
					!item.submenu &&
						(checkHasPermission(item.baboonPermissions) || checkUserTypeAccess(item.baboonUserAccess))
				"
				:name="isSidebarOpen ? item.slug : ''"
				:to="{ name: item.routeName }"
				:icon="item.icon"
			/>
			<app-accordion
				v-if="
					!!item.submenu &&
						(checkHasPermission(item.baboonPermissions) || checkUserTypeAccess(item.baboonUserAccess))
				"
				:is-opened="isActiveHeader(item) && isSidebarOpen"
				:hide-caret="!isSidebarOpen"
				:is-sidebar-open="isSidebarOpen"
				@onOpen="$emit('onSidebarItemOpened')"
			>
				<template v-slot:header>
					<div :class="['app-route', { 'app-route-active': isActiveHeader(item) }]">
						<app-icon class="app-route-icon" :icon="item.icon" />
						<span class="app-route-title">{{ isSidebarOpen ? $t(item.slug) : '' }}</span>
					</div>
				</template>
				<div v-for="subItem in item.submenu" :key="subItem.slug">
					<sidebar-item
						v-if="
							checkHasPermission(subItem.baboonPermissions) ||
								checkUserTypeAccess(subItem.baboonUserAccess)
						"
						class="app-route-child"
						:name="isSidebarOpen ? subItem.slug : ''"
						:to="{ name: subItem.routeName }"
						:icon="subItem.icon"
					/>
				</div>
			</app-accordion>
		</div>
	</div>
</template>

<script>
	import SidebarItem from './Sidebar/SidebarItem';
	import { getAvailableItems } from '@/components/layout/Sidebar/sidebarItems';
	import AppAccordion from '@/components/app/AppAccordion';
	import AppIcon from '@/components/app/AppIcon';
	import { mapGetters } from 'vuex';
	import { checkHasPermission, checkUserTypeAccess } from '@/middlewares/permissions';

	export default {
		name: 'Navigation',
		components: {
			AppAccordion,
			SidebarItem,
			AppIcon,
		},
		emits: ['onSidebarItemOpened'],
		props: ['isSidebarOpen'],
		data() {
			return {
				sidebarItems: getAvailableItems(),
			};
		},
		computed: {
			...mapGetters({
				departmentId: 'departmentId',
				selectedRestaurants: 'selectedRestaurants',
			}),
		},
		methods: {
			isActiveHeader(item) {
				return this.$route.path.indexOf(`/${item.slug}`) === 0;
			},
			checkHasPermission,
			checkUserTypeAccess,
		},
	};
</script>
